
// import {WOW} from '../../../node_modules/wowjs/dist/wow';
// new WOW().init();
import AOS from 'aos';

$(document).ready(function(){
  setTimeout(function(){
    AOS.init({
      disable: false,
      duration: 500,
      offset: 30,
      easing: 'ease-in-out-sine'
    });
  },300)
  
})

window.onresize = function(){
  AOS.refresh()
}


$(document).ready(function(){

  // 表单点击提示文字上移
  $('.contact-form .form-item.input input,.contact-form .form-item.input textarea').focus(function () {
    if (!$(this).parents('.form-item').hasClass('active')) {
        $(this).parents('.form-item').addClass('active')
    }
  }).blur(function () {
    if ($(this).val() == '') {
      $(this).parents('.form-item').removeClass('active')
    }
  })

  // 模拟select
  $('.select input').on('click',function(){
    let $parent = $(this).closest('.select')
    $parent.siblings('.select').removeClass('show-option')

    let select_input = $parent.siblings('.select').find('input')
    select_input.each(function(index,el){
      if($(el).val() == ''){
        $(el).closest('.form-item.select').removeClass('active')
      }
    })

    if(!$parent.hasClass('show-option')){
      $parent.addClass('show-option')
    }
    if(!$parent.hasClass('active')){
      $parent.addClass('active')
    }
  })
  
  let val
  let sub_val
  $('.select .select-list li .title').on('click',function(){
    let that = $(this)
    let parents = that.closest('.select')
    val = $(this).html()

    if(that.siblings('.sub-option').length == 0){
      parents.find('input').val(val)
      parents.removeClass('show-option')
      that.closest('li').addClass('on').siblings().removeClass('on')
    }else{
      that.siblings('.sub-option').addClass('show')
      that.closest('li').siblings().find('.sub-option').removeClass('show')
      that.closest('li').addClass('on').siblings().removeClass('on')
    }
  })
  $('.select .select-list li .sub-option .option').on('click',function(){
    sub_val = $(this).html()
    $('.select .select-list li .sub-option .option').removeClass('on')
    $(this).addClass('on')
    let parents = $(this).closest('.select')
    parents.find('input').val(val+' | '+sub_val)
    parents.removeClass('show-option').find('.sub-option').removeClass('show')
  })
  
  $('body').on('click',function(e){
    if($(e.target).parents('.form-item.select').length == 0){
      $('.form-item.select').removeClass('show-option')
      $('.form-item.select .sub-option').removeClass('show')

      let select_input = $('.form-item.select input')
      select_input.each(function(index,el){
        if($(el).val() == ''){
          $(el).closest('.form-item.select').removeClass('active')
        }
      })
    }
  })


  $('.form-checkbox .checkbox').on('click',function(){
    var checkbox = document.getElementById('policy')
    console.log('checkbox',checkbox.checked)
    checkbox.checked = !checkbox.checked;
  })
})